import { h } from "preact";
import styles from "./Menu.css";

const Menu = (props) => {
  return <div class={styles.container}>{props.children}</div>;
};

export default Menu;
